import React, { Fragment, useState } from 'react';
import {
  Card, Button, UncontrolledDropdown, Modal, ModalHeader, ModalFooter, ModalBody,
  DropdownMenu, DropdownItem, DropdownToggle, Row, Input

} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { putAPI_Update_Vouchers, gAPI_Vouchers_By_Id, postAPI_Create_Vouchers, dAPI_Vouchers_By_Id,
  gAPI_Internal_Property_By_Id } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import GiftCardForm from './forms/giftCardForm';
import ReviewVoucher from './forms/ReviewVoucher';
import VoucherConnection from './forms/VoucherConnection';
import VouchersForm from './forms/VouchersForm';
import {
  FacebookShareButton,
  TwitterShareButton
} from "react-share";
import {
  FacebookIcon,
  TwitterIcon,
} from "react-share";
import CopyToClipboard from 'react-copy-to-clipboard';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import AdsForm from './forms/AdsForm';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';

const VoucherListItem = ({ item, isBuyOption,memberShipTags, amadeus, mews, reportingTagData, LoadData, handleVoucherName, voucherList, handleVoucherPaymentsByIdforthirdParty, xolaIntegration, locale, isHostedPageIntegration
  , invitation, propertyId, handleReject, handleApproval, inviteVoucher, handleGenerateCode, extractData, ShowInviteVoucher, currency, handleBuyOptionSetings, handleVoucherFilter, handleVoucherPaymentsById }) => {
  const [id, setId] = useState(item.id);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isgiftCard, setIsGiftCard] = useState(false);
  const [isBuyOptionForm, setisBuyOptionForm] = useState(false);
  const [currentInvitation, setCurrentInvitation] = useState();
  const [websitelink, setWebsiteLink] = useState('');
  const [propertyData, setPropertyData] = useState({
    bmbVoucherProcessingFee: 0
  });
  const [showReviewVoucher, setShowReviewVoucher] = useState(false);
  const [showConnectedVoucher, setShowConnectedVoucher] = useState({
    'groups': [],
    'property': [],
    'id': [],
    'senderGroupId': '',
    'senderPropertyId': '',
    'isShow': false,
    'invitationtype': ''
  });
  const [voucherData, setVoucherData] = useState({
    'connectionId': '',
    'invitationId': '',
    'processingFee': '',
    'approvalStatus': '',
    'groupId': item.groupId
  });  
  const [deleteVisible, setDeleteVisible] = useState(false);
  let [voucher, setVoucher] = useState();
  let [facebookQuote, setFacebookQuote] = useState('');
  let [twitterQuote, setTwitterQuote] = useState('');
  let [whatsAppQuote, setWhatsAppQuote] = useState('');
  let [directLinkUrl, setDiretLinkUrl] = useState('');
  const [isShow, setIsShow] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const handleViewDetails = (id, connection, status) => {
    let data = invitation !== undefined && invitation.filter((f) => f.invitationId === id);
    if (data.length > 0) {
      setVoucherData({ connectionId: connection, groupId: item.groupId, approvalStatus: status, invitationId: data[0].invitationId, processingFee: data[0].processingFee });
    }
  };

  const handleWebsiteLink = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_By_Id}/${item.id}`,
    }).then((res) => {
      // if (res.data.websiteLink !== "" && res.data.websiteLink !== null)
      //   setWebsiteLink(res.data.websiteLink);
      // else {
        setWebsiteLink(process.env.REACT_APP_VOUCHER_URL + "/vhp?id=" + item.id);
      //}
      setShareModal(true); 
    });
  }
  const handleVoucherDelete = (id) => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Vouchers_By_Id}/${id}`,
    }).then((res) => {
      setDeleteVisible(false);
      LoadData();      
    });
  }  
  const toggle=()=>{
    setDeleteVisible(false);
  }
  const close_clicked = () => {
    setShowReviewVoucher(!showReviewVoucher);
  }
  const handleConnectedVoucher = (id) => {
    let temp = invitation.filter((f) => f.invitationId === id);    
    if (temp.length > 0) {
      if (temp[0].groups.length === 1 && temp[0].propertys.length === 1) {
        handleReject(item.id, item.invitationId, 'Approve', item.processingFee);
        handleShow();
        return;
      }
      setShowConnectedVoucher({
        groups: temp[0].groups, property: temp[0].propertys, id: temp[0].id, isShow: true,
        senderGroupId: temp[0].senderGroup,
        senderPropertyId: temp[0].senderProperty, invitationtype: temp[0].type
      });
      setCurrentInvitation(temp[0]);
    }
  };
  const handlePreview = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_By_Id}/${id}`,
    }).then((res) => {
      if (res.data.taxIncluded === true) {
        let val = parseFloat(res.data.price) -
          parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0);
        res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
          val)
        ).toFixed(2);
      } else {
        res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
          parseFloat(res.data.price) -
          parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0))
        ).toFixed(2);
      }
      res.data.taxIncluded = res.data.taxIncluded.toString();
      setVoucher(res.data);
      setShowReviewVoucher(!showReviewVoucher)
      if (res.data.propertyId === propertyId) {
        loadProperty(res.data.propertyId, voucherData.groupId === undefined ? getGroupID() : voucherData.groupId);
      } else {
        loadProperty(res.data.propertyId, voucherData.groupId === undefined ? getGroupID() : voucherData.groupId);
      }
    });
  };
  const loadProperty = (propertyId, group_id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group_id}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      })
  };
  const handleUpdate = (type) => {
    if (type === 'Approve') {
      handleConnectedVoucher(item.invitationId);
    }
    else {
      handleReject(item.id, voucherData.invitationId, 'Reject', item.processingFee);
      handleShow();
    }
  };
  const handleDuplicateVoucher = (Id) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Vouchers_By_Id}/${Id}`,
    }).then((res) => {
      res.data.status = 0;
      res.data.isDuplicate = true;
      res.data.creator = 'Admin';
      res.data.groupId = getGroupID();
      res.data.propertyId = propertyId;
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Vouchers}`,
        data: res.data
      }).then((res) => {
        LoadData();
      });
    });
  };
  const handleShow = () => {
    setIsShow(false);
  }
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Vouchers}/${id}`,
      data: formmatedData,
    }).then(() => {
      extractData();
      if (isBuyOption) {
        setisBuyOptionForm(!isBuyOptionForm);
      } else {
        setIsUpdating(!isUpdating);
      }
    });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This item will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleVoucherDelete(item.id)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>
      {item.isAds === false ?
        <Fragment>
          {item.thirdPartyVoucher && item.approvalStatus === '3' ? null :
            <Colxx xxs="12">
              <Card className="d-flex flex-row mb-3">
                <div className="react-photo-gallery--gallery">
                  <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
                    <div style={{
                      margin: '2px', 'position': 'relative'
                    }}>
                      <img
                        alt="Thumbnail"
                        src={
                          item.images[0]
                            ? item.images[0].url
                            : 'https://www.digitalseotool.com/placeholder/600x480/d5d5d5/584959'
                        }
                        className="ml-2 my-3 image-thumbnail responsive border-0"
                      />
                      {item.thirdPartyVoucher ? <span className="badge badge-pill badge-primary
            position-absolute badge badge-top-voucher">
                        {item.propertyName}</span> : null}
                    </div>
                  </div>
                </div>

                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    {/* {item.thirdPartyVoucher && item.approvalStatus === '1' && (
                  <Fragment>
                    <button type="button" className="btn btn-link" onClick={() => {
                      handleApproval(item.connectionId, item.invitationId);
                    }}>Approve </button>
                    <button type="button" className="btn btn-link" onClick={() => {
                      handleReject(item.connectionId, item.invitationId);
                    }}>Reject </button>
                  </Fragment>
                )} */}
                    <p className="mb-1 text-center text-muted text-small w-25 w-sm-100">
                      <b>{item.name}</b>

                    </p>
                    <p className="mb-1 text-left text-muted text-small w-20 w-sm-100">
                      {item.thirdPartyVoucher && item.approvalStatus === '1' ?
                        <b style={{ color: 'red' }}>Waiting for approval</b>
                        : <b>{item.status === 'ActiveMembers' ? 'MembersOnly' : item.status}</b>}
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      {currency} {item.price}
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      {item.discount}%
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-15 w-sm-100">
                      <button type="button" className="btn btn-link" onClick={() => {
                        if (!item.thirdPartyVoucher) {
                          handleVoucherPaymentsById(item.id, "2");
                          handleVoucherFilter('Active');
                        } else {
                          handleVoucherPaymentsByIdforthirdParty(item.id, "2", item.groupId, item.propertyId);
                          handleVoucherFilter('Active');
                        }
                      }}>Purchased : {item.totalSell} </button>
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      <button type="button" className="btn btn-link" onClick={() => {
                        if (!item.thirdPartyVoucher) {
                          handleVoucherPaymentsById(item.id, "0");
                          handleVoucherFilter('Redeem');
                        } else {
                          handleVoucherPaymentsByIdforthirdParty(item.id, "0", item.groupId, item.propertyId);
                          handleVoucherFilter('Redeem');
                        }
                      }}>Redeemed : {item.totalRedeem} </button>
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      {currency}
                      {item.discountedPrice}
                    </p>
                    {item.isCard === true ? 
                      <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      <span style={{ color: 'green' ,background:'#b9f6b9', padding:'5px 10px' }} className="ml-1" >
                        <FontAwesomeIcon icon={faDollarSign}></FontAwesomeIcon>  Gift Card
                      </span>
                    </p>:
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      <span style={{ color: 'red' ,background:'antiquewhite', padding:'5px 10px' }} className="m-1" >
                       <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" className='mr-1' viewBox="0 0 24 24" 
                         style={{fill: 'red'}}><path d="M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-.8 6.4 6-8 1.6 1.2-6 8-1.6-1.2zM15 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2z"></path></svg>
                        Voucher
                       </span>
                    </p>}
                    {/* {!item.thirdPartyVoucher ? (<div className="w-15 text-left w-sm-100">
                  <UpdateVouchersForm
                    id={item.id}
                    propertyId={propertyId}
                    isBuyOption={isBuyOption}
                    LoadData={LoadData}
                  /> </div>) : <div className="w-15 text-left w-sm-100"></div>} */}
                    {!item.thirdPartyVoucher && item.approvalStatus !== 1 ?
                      <UncontrolledDropdown className="w-15 text-center w-sm-100">
                        <DropdownToggle caret color="outline-dark" size="xs">
                          more
                        </DropdownToggle>
                        <DropdownMenu>
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Accept'
                            onClick={() => {
                              if (item.isCard === false) {
                                setId(item.id);
                                setIsUpdating(!isUpdating);
                              } else {
                                setId(item.id);
                                setIsGiftCard(!isgiftCard);
                              }
                            }}
                          >Edit
                          </DropdownItem>}
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Accept'
                            onClick={() => setDeleteVisible(true)}
                          >Delete
                          </DropdownItem>}
                          {item.options && !item.thirdPartyVoucher && <DropdownItem
                            key='Option'
                            onClick={() => {
                              handleBuyOptionSetings(true, item.id, item.name);
                            }}
                          > Manage Variants
                          </DropdownItem>}
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Accept'
                            onClick={() => {
                              handleDuplicateVoucher(item.id);
                            }}
                          >Duplicate
                          </DropdownItem>}

                          <DropdownItem>
                            <p onClick={() => handlePreview()}>
                              Preview
                            </p>
                          </DropdownItem>
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Generate'
                          > <p onClick={() => { handleVoucherName(item.name, item.id); handleGenerateCode(true) }}>

                              Pre-generate Codes
                            </p>

                          </DropdownItem>}
                          {item.isHostedPage === true && <DropdownItem
                            key='View'
                            onClick={() => { handleWebsiteLink();}}
                          >
                            Post on Social Media
                          </DropdownItem>}
                        </DropdownMenu>

                      </UncontrolledDropdown> :
                      <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                        <DropdownToggle caret color="outline-dark" size="xs">
                          more
                        </DropdownToggle>
                        <DropdownMenu>
                          {item.thirdPartyVoucher && item.approvalStatus === '1' ? (<Fragment>
                            <DropdownItem
                              key='Accept'
                              onClick={() => {
                                // if (item.invitationtype === 'Sell')
                                //   handleApproval(item.id, item.invitationId);
                                // else {
                                handleConnectedVoucher(item.invitationId);
                              }}
                            >Accept
                            </DropdownItem>
                            <DropdownItem
                              key='Reject'
                              onClick={() => {
                                handleReject(item.id, item.invitationId, 'Reject', item.processingFee);
                              }}
                            >
                              Reject
                            </DropdownItem>
                          </Fragment>) : <Fragment>

                          </Fragment>}
                          {item.thirdPartyVoucher && item.approvalStatus === '2' &&
                            < DropdownItem
                              key='Selling'
                              onClick={() => {
                                handleReject(item.id, item.invitationId, 'StopSelling', item.processingFee);
                              }}
                            >
                              Stop Selling
                            </DropdownItem>
                          }
                          {item.thirdPartyVoucher && item.approvalStatus === '4' &&
                            < DropdownItem
                              key='Reject'
                              onClick={() => {
                                handleReject(item.id, item.invitationId, 'StartSelling', item.processingFee);
                              }}
                            >
                              Start Selling
                            </DropdownItem>
                          }
                          {item.thirdPartyVoucher && <DropdownItem
                            key='View2345'
                            onClick={() => { handleViewDetails(item.invitationId, item.connectionId, item.approvalStatus); setId(item.id); setIsShow(!isShow); }}
                          >
                            View details
                          </DropdownItem>}
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Generate'
                          > <p onClick={() => { handleVoucherName(item.name, item.id); handleGenerateCode(true) }}>

                              Pre-generate Codes
                            </p>

                          </DropdownItem>}

                          <DropdownItem>
                            <p onClick={() => handlePreview()}>
                              Preview
                            </p>
                          </DropdownItem>
                          {item.isHostedPage === true && <DropdownItem
                            key='View'
                            onClick={() => { handleWebsiteLink();}}
                          >
                            Post on Social Media

                          </DropdownItem>}
                        </DropdownMenu>

                      </UncontrolledDropdown>
                    }
                  </div>
                </div>
              </Card >
              {showReviewVoucher && <ReviewVoucher close_clicked={close_clicked} locale={locale} isCheckoutView={false} propertyData={propertyData} isVoucherEngine={true} data={voucher}></ReviewVoucher>}
            </Colxx >
          }
          {
            isShow && <VouchersForm
              formLabel="Update the Voucher"
              visible={isShow}
              memberShipTags={memberShipTags}
              reportingTagData={reportingTagData}
              toggle={() => {
                setIsShow(!isShow);
              }}
              id={id}
              xolaIntegration={xolaIntegration}
              handleUpdate={handleUpdate}
              isHostedPageIntegration={isHostedPageIntegration}
              voucherName={item.name}
              amadeus={amadeus}
              mews={mews}
              approvalStatus={voucherData.approvalStatus}
              invitationId={item.invitationId}
              processingFee={voucherData.processingFee}
              propertyId={propertyId}
              handleReject={handleReject}
              thirdPartyVoucher={item.thirdPartyVoucher}
              groupId={voucherData.groupId}
            />
          }
          <div>
            {isUpdating && (
              <VouchersForm
                memberShipTags={memberShipTags} 
                reportingTagData={reportingTagData}
                formLabel="Update the Voucher"
                visible={isUpdating}
                xolaIntegration={xolaIntegration}
                toggle={() => {
                  setIsUpdating(!isUpdating);
                }}
                id={id}
                amadeus={amadeus}
                mews={mews}
                submit={handleSubmit}
                inviteVoucher={inviteVoucher}
                isHostedPageIntegration={isHostedPageIntegration}
                approvalStatus={voucherData.approvalStatus}
                invitationId={item.invitationId}
                voucherName={item.name}
                thirdPartyVoucher={item.thirdPartyVoucher}
                handleReject={handleReject}
                ShowInviteVoucher={ShowInviteVoucher}
                propertyId={propertyId}
                groupId={voucherData.groupId}
              />
            )}
          </div>
          <div>
            {isgiftCard && (
              <GiftCardForm
              memberShipTags={memberShipTags} 
                formLabel="Update the E-GIft Card"
                visible={isgiftCard}
                xolaIntegration={xolaIntegration}
                toggle={() => {
                  setIsGiftCard(!isgiftCard);
                }}
                id={id}
                amadeus={amadeus}
                mews={mews}
                submit={handleSubmit}
                reportingTagData={reportingTagData}
                inviteVoucher={inviteVoucher}
                isHostedPageIntegration={isHostedPageIntegration}
                approvalStatus={voucherData.approvalStatus}
                invitationId={item.invitationId}
                voucherName={item.name}
                thirdPartyVoucher={item.thirdPartyVoucher}
                handleReject={handleReject}
                ShowInviteVoucher={ShowInviteVoucher}
                propertyId={propertyId}
                groupId={voucherData.groupId}
              />
            )}
          </div>
          
        </Fragment> :
        <Fragment>
          <Colxx xxs="12">
            <Card className="d-flex flex-row mb-3">

              <Fragment>
                {item.images !== null &&
                  <div className="react-photo-gallery--gallery">
                    <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
                      <div style={{
                        margin: '2px', 'position': 'relative'
                      }}>
                        {item.images !== null &&
                          <img
                            alt="Thumbnail"
                            src={
                              item.images[0]
                                ? item.images[0].url
                                : 'https://via.placeholder.com/250x150'
                            }
                            className="ml-2 my-3 list-thumbnail responsive border-0"
                          />}
                        {item.thirdPartyVoucher ? <span className="badge badge-pill badge-primary
            position-absolute badge badge-top-voucher">
                          {item.propertyName}</span> : null}
                      </div>
                    </div>
                  </div>}
                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">

                    <p className="mb-1 text-center text-muted text-small w-25 w-sm-100">
                      <b>{item.title}</b>
                    </p>
                    {item.thirdPartyVoucher && item.approvalStatus === '1' ?
                      <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                        <b style={{ color: 'red' }}>Waiting for approval</b>                      
                      </p>
                      : null}

                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      {moment(item.startDate).format('YYYY-MM-DD')}
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      {moment(item.expiryDate).format('YYYY-MM-DD')}
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      {item.status}
                    </p>
                    <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                      <span style={{ color: 'green' }}>Ad</span>
                    </p>                   
                     {!item.thirdPartyVoucher && item.approvalStatus !== 1 ?
                      < UncontrolledDropdown className="w-15 text-center w-sm-100">
                        <DropdownToggle caret color="outline-dark" size="xs">
                          more
                        </DropdownToggle>
                        <DropdownMenu>
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Accept'
                            onClick={() => {
                              setId(id);
                              setIsUpdating(!isUpdating)
                            }}                          
                          >Edit
                          </DropdownItem>}
                          {!item.thirdPartyVoucher && <DropdownItem
                            key='Accept'
                            onClick={() => setDeleteVisible(true)}
                          >Delete
                          </DropdownItem>}
                        </DropdownMenu>

                      </UncontrolledDropdown> :
                      <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                        <DropdownToggle caret color="outline-dark" size="xs">
                          more
                        </DropdownToggle>
                        <DropdownMenu>
                          {item.thirdPartyVoucher && item.approvalStatus === '1' ? (<Fragment>
                            <DropdownItem
                              key='Accept'
                              onClick={() => {
                                // if (item.invitationtype === 'Sell')
                                //   handleApproval(item.id, item.invitationId);
                                // else {
                                handleConnectedVoucher(item.invitationId);
                              }}
                            >Accept
                            </DropdownItem>
                            <DropdownItem
                              key='Reject'
                              onClick={() => {
                                handleReject(item.id, item.invitationId, 'Reject', item.processingFee);
                              }}
                            >
                              Reject
                            </DropdownItem>
                          </Fragment>) : <Fragment>

                          </Fragment>}
                          {item.thirdPartyVoucher && item.approvalStatus === '2' &&
                            < DropdownItem
                              key='Selling'
                              onClick={() => {
                                handleReject(item.id, item.invitationId, 'StopSelling', item.processingFee);
                              }}
                            >
                              Stop Showing
                            </DropdownItem>
                          }
                          {item.thirdPartyVoucher && item.approvalStatus === '4' &&
                            < DropdownItem
                              key='Reject'
                              onClick={() => {
                                handleReject(item.id, item.invitationId, 'Approve', item.processingFee);
                              }}
                            >
                              Start Showing
                            </DropdownItem>
                          }
                          {item.thirdPartyVoucher && <DropdownItem
                            key='View2345'
                            onClick={() => { handleViewDetails(item.invitationId, item.connectionId, item.approvalStatus); setId(item.id); setIsShow(!isShow); }}
                          >
                            View details
                          </DropdownItem>}                        
                          
                        </DropdownMenu>

                      </UncontrolledDropdown>
                    }
                  </div>
                
                </div>
              </Fragment>
            </Card>
          
            {showReviewVoucher && <ReviewVoucher close_clicked={close_clicked} locale={locale} isCheckoutView={false} propertyData={propertyData} isVoucherEngine={true} data={voucher}></ReviewVoucher>}
          </Colxx >
          {
            isUpdating && <AdsForm
              formLabel="Update the Ad"
              visible={isUpdating}
              reportingTagData={reportingTagData}
              toggle={() => {
                setIsUpdating(!isUpdating);
              }}
              id={id}
              xolaIntegration={xolaIntegration}
              handleUpdate={handleUpdate}
              isHostedPageIntegration={isHostedPageIntegration}
              voucherName={item.name}
              amadeus={amadeus}
              mews={mews}
              submit={handleSubmit}
              approvalStatus={voucherData.approvalStatus}
              invitationId={item.invitationId}
              processingFee={voucherData.processingFee}
              propertyId={propertyId}
              handleReject={handleReject}
              thirdPartyVoucher={item.thirdPartyVoucher}
              groupId={voucherData.groupId}
            />
          }
            {
            isShow && <AdsForm
              formLabel="Update the Ad"
              visible={isShow}
              reportingTagData={reportingTagData}
              toggle={() => {
                setIsShow(!isShow);
              }}
              id={id}
              xolaIntegration={xolaIntegration}
              handleUpdate={handleUpdate}
              isHostedPageIntegration={isHostedPageIntegration}
              voucherName={item.name}
              amadeus={amadeus}
              mews={mews}
              submit={handleSubmit}
              approvalStatus={voucherData.approvalStatus}
              invitationId={item.invitationId}
              processingFee={voucherData.processingFee}
              propertyId={propertyId}
              handleReject={handleReject}
              thirdPartyVoucher={item.thirdPartyVoucher}
              groupId={voucherData.groupId}
            />
          }

        </Fragment>

      }
      {
            showConnectedVoucher.isShow && <VoucherConnection propertyId={propertyId}
              voucherList={voucherList} id={showConnectedVoucher.id}
              LoadData={LoadData} groups={showConnectedVoucher.groups}
              invitationId={showConnectedVoucher.id}
              senderGroupId={showConnectedVoucher.senderGroupId}
              senderPropertyId={showConnectedVoucher.senderPropertyId}
              invitation={currentInvitation}
              handleShow={handleShow}
              extractData={extractData}
              visible={showConnectedVoucher.isShow}
              handleApproval={handleApproval}
              voucherId={id}
              property={showConnectedVoucher.property}
              invitationtype={showConnectedVoucher.invitationtype}
              toggle={() => setShowConnectedVoucher({ ...showConnectedVoucher, isShow: false })}
            ></VoucherConnection>
          }
          {generateDeleteButton()}
      <Modal
        isOpen={shareModal}
        toggle={() => setShareModal(false)}
        size="lg"
        style={{ maxWidth: '30%' }}
      >
        <ModalHeader toggle={() => setShareModal(false)}><h3>SHARE VOUCHER</h3></ModalHeader>
        {/* <ModalBody>
          <div className="mb-3">
          <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Url for your facebook post</Row>
          <Row className="mb-2">
            <Input
              type="text"
              defaultValue={websitelink}
              onChange={event => {
                setWebsiteLink(event.target.value);
              }}
              disabled={true}
            />
          </Row>         
          <Row className="justify-content-center">
            <FacebookShareButton
              url={websitelink}
              className='facebook-button'
              windowWidth={900}
              windowHeight={900}
            >
              <FacebookIcon size={40} /><span >Share</span>
            </FacebookShareButton>
          </Row>
        </div><div className="mb-3">
            <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Url for your twitter post</Row>
            <Row className="mb-2">
              <Input
                type="text"
                defaultValue={websitelink}
                onChange={event => {
                  setWebsiteLink(event.target.value);
                }}
                disabled={true}
              />
            </Row>
            <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Quote for your twitter post</Row>
            <Row className="mb-2">
              <Input
                type="textarea"
                defaultValue={twitterQuote}
                onChange={event => {
                  setTwitterQuote(event.target.value);
                }}                
              />
            </Row>
            <Row className="justify-content-center">
              <TwitterShareButton
                url={websitelink}
                title={twitterQuote}
                className='twitterButton'
                windowWidth={900}
                windowHeight={900}
              >
                <TwitterIcon size={40} /><span >Share</span>
              </TwitterShareButton>
            </Row>
          </div>
          {/* <div className="mb-3">
            <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Url for your WhatsApp post</Row>
            <Row className="mb-2">
              <Input
                type="text"
                defaultValue={directLinkUrl}
                onChange={event => {
                  setDiretLinkUrl(event.target.value);
                }}
                disabled={true}
              />
              
            </Row>
            {/* <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Quote for your WhatsApp post</Row>
            <Row className="mb-2">
              <Input
                type="textarea"
                defaultValue={whatsAppQuote}
                onChange={event => {
                  setWhatsAppQuote(event.target.value);
                }}
                
              />
            </Row> 
            <Row className="justify-content-center">
              <WhatsappShareButton
                url={directLinkUrl}
                title={whatsAppQuote}
                separator=":: "
                className='whatsapp-button'
              >
                <WhatsappIcon size={40} /><span >Share</span>
              </WhatsappShareButton>
            </Row>
          </div> 
          {isHostedPageIntegration !== undefined && isHostedPageIntegration === true && <div className="mb-3">
            <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Url for Direct Link</Row>
            <Row className="mb-2">
              <Input
                type="text"
                defaultValue={websitelink}
                onChange={event => {
                  setWebsiteLink(event.target.value);
                }}
                disabled={true}
              />
            </Row>
            <Row className="justify-content-center">
              <CopyToClipboard text={websitelink} onCopy={() => {
                NotificationManager.success(
                  '',
                  'Successfully copied to clipboard.',
                  3000,
                  null,
                  null,
                  'success'
                );
              }}>
                <Button
                  color="primary"
                  size="xs"
                  style={{
                    marginTop: '10px', marginLeft: '15px', padding: '12px',
                    borderRadius: '11px',
                    fontSize: '18px'
                  }}
                >
                  Copy the Url
                </Button>
              </CopyToClipboard>
            </Row>
          </div>}
        </ModalBody> */}
        <ModalBody>
          <div className="mb-3">

            <Row style={{ fontSize: '18px' }} className="justify-content-center mb-2">Quote for your twitter post</Row>
            <Row className="mb-2">
              <Input
                type="textarea"
                defaultValue={twitterQuote}
                onChange={event => {
                  setTwitterQuote(event.target.value);
                }}
              />
            </Row>
            <Row className="justify-content-center">
              <FacebookShareButton
                url={websitelink}
                className='facebook-button'
                windowWidth={900}
                windowHeight={900}
              >
                <FacebookIcon size={40} /><span >Share</span>
              </FacebookShareButton>
              <div className='ml-2'>
                <TwitterShareButton
                  url={websitelink}
                  title={twitterQuote}
                  className='twitterButton'
                  windowWidth={900}
                  windowHeight={900}
                >
                  <TwitterIcon size={50} /><span >Share</span>
                </TwitterShareButton>
              </div>
              {/* <div className='ml-2'>
            <TwitterShareButton
                url={websitelink}
                title={twitterQuote}
                className='twitterButton'
                windowWidth={900}
                windowHeight={900}
              >
                <TwitterIcon size={40} /><span >Share</span>
              </TwitterShareButton>
            </div> */}
              <div className='ml-2'>
                <CopyToClipboard text={websitelink} onCopy={() => {
                  NotificationManager.success(
                    '',
                    'Successfully copied to clipboard.',
                    3000,
                    null,
                    null,
                    'success'
                  );
                }}>
                  <Button
                    color="primary"
                    size="xs"
                    style={{
                      padding: '16px',
                      borderRadius: '11px',
                      fontSize: '18px'
                    }}
                  >
                    Copy Url
                  </Button>
                </CopyToClipboard>
              </div>

            </Row>
          </div>


        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setShareModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal >

    </Fragment >
  );
}

export default React.memo(VoucherListItem);





